{
  "Fintraffic-traffic": "Trafikläget",
  "Fintraffic-feedback": "Responsiveness",
  "Fintraffic-train": "Tågavgångar",
  "Fintraffic-digitraffic": "Digitraffic",
  "Fintraffic-digitransit": "Digitransit",
  "Fintraffic-nap": "NAP",
  "Fintraffic-contact": "Kontaktinformation",
  "Fintraffic-contactLink": "kontaktuppgifter",
  "Fintraffic-privacy": "Dataskydd",
  "Fintraffic-accessibility": "Tillgänglighetsutlåtande",
  "Fintraffic-about": "Om",
  "Fintraffic-instructions": "Instruktioner och tillkännagivanden",
  "Fintraffic-terms": "Användarvillkor",
  "Fintraffic-support": "Stöd",
  "Fintraffic-channels": "Kundtjänst",
  "Fintraffic-fintrafficApp": "Fintraffic Appen",
  "Fintraffic-fintrafficAppLink": "digitalatjanster/fintraffic_appen",
  "Entur-cooperation": "Entur samarbete",
  "_title": "Hållplats- och tillgänglighetsdatabas"
}
